import {
  NoConfirmationDefaultNavigatorConfiguration,
  NoConfirmationPreQualifiedPatientNavigatorConfiguration
} from "../../App/Compositions/NavigatorConfigurations";
import {
  noConfirmationCenterSelectableBookingStepConfigurations,
  screeningStepConfigurations
} from "../../App/Compositions/StepConfigurations";
import { Flow } from "../../Types/IFlow";

const noConfirmationNewPatientFlowName = "NoConfirmationNewPatientFlow";

/** The flow that a new patient should experience when booking without a confirmation step. */
class NoConfirmationNewPatientFlow extends Flow {
  static readonly flowName = noConfirmationNewPatientFlowName;

  constructor(isPatientPreQualified: boolean) {
    isPatientPreQualified
      ? super(
          noConfirmationNewPatientFlowName,
          { ...noConfirmationCenterSelectableBookingStepConfigurations },
          NoConfirmationPreQualifiedPatientNavigatorConfiguration
        )
      : super(
          noConfirmationNewPatientFlowName,
          { ...screeningStepConfigurations, ...noConfirmationCenterSelectableBookingStepConfigurations },
          NoConfirmationDefaultNavigatorConfiguration
        );
  }
}

export default NoConfirmationNewPatientFlow;
